window.positionatePopElement = function(
                                 $trigger, $popElement, iMaxHeight /** = 225 **/,
                                 bResizeable /** = true **/,
                                 bPullRight /** = $popElement.is(".pull-right") **/,
                                 bDropUp /** = $popElement.is(".bottom-up") **/
                              )
{


	if(!isset(iMaxHeight))   iMaxHeight   = 225;
	if(!isset(bResizeable))  bResizeable  = true;

	if(!isset(bPullRight))   bPullRight   = $popElement.is(".pull-right");
	if(!isset(bDropUp))      bDropUp      = $popElement.is(".bottom-up");

	var iWidth = $trigger.outerWidth();
	var iHeight = $trigger.outerHeight();
	var oOffset = $trigger.offset();

	var iLeft = oOffset.left;
	var iTop = oOffset.top;

	var $window = $(window);
	// VP — viewport
	var iWidthVP  = $window.width();
	var iHeightVP = $window.height();
	// Прибавка за счет скролла
	var iLeftScroll = $window.scrollLeft();
	var iTopScroll  = $window.scrollTop();
	// Реальное положение относительно viewport
	var iLeftVP = iLeft - iLeftScroll;
	var iTopVP  = iTop  - iTopScroll;

	// Итак, теперь высчитаем расстояния, которые у нас остаются снизу и сверху
	var iSpaceTop = iTopVP;
	var iSpaceBottom = iHeightVP - iTopVP - iHeight;

	if(iSpaceBottom >= iMaxHeight + 18) // add 18 to have some air
	{
		// тогда все нормально и оставляем как есть — открываем вниз
		//$popElement.removeClass("bottom-up"); // если он раньше стоял
		bDropUp = false;
	}
	else if(iSpaceTop >= iMaxHeight + 18)
	{
		// тогда открываем наверх.
		//$popElement.addClass("bottom-up");
		bDropUp = true;
	}
	else
	{
		// значит места у нас очень мало и поэтому выберем просто ту сторону, в которой высота больше.
		if(iSpaceBottom >= iSpaceTop)
		{
			// тогда все нормально и оставляем как есть — открываем вниз
			//$popElement.removeClass("bottom-up"); // если он раньше стоял
			iMaxHeight = iSpaceBottom - 18; // add 18 to have some air
			bDropUp = false;
		}
		else
		{
			// тогда открываем наверх.
			//$popElement.addClass("bottom-up");
			iMaxHeight = iSpaceTop - 18; // add 18 to have some air
			bDropUp = true;
		}
	}

	if(bResizeable)
	{
		$popElement.css("max-height", iMaxHeight);
		// $popElement.css("min-width", iWidth+18); // непонятно, зачем это было нужно …
	}

	oOffset.right = (iWidthVP - (oOffset.left + iWidth));
	oOffset.bottom = (iHeightVP - (oOffset.top + iHeight));

	// Теперь на этом этапе учтем div.absolute…
	var $absolute = $trigger.closest("div.absolute");
	if($absolute.length)
	{
	  //alert("absolute!");
	  oOffset.left += $absolute.scrollLeft();
	  oOffset.top += $absolute.scrollTop();
	  oOffset.right -= $absolute.scrollLeft();
	  oOffset.bottom -= $absolute.scrollTop();
	  //console.log("offset: %o", offset);

	  // Вычтем скролл, если есть:
	  oOffset.right -= $absolute[0].offsetWidth - $absolute[0].clientWidth;
	  oOffset.bottom -= $absolute[0].offsetHeight - $absolute[0].offsetHeight;
	}

	var oCss = {};
	oCss.position = "absolute";

	if(bPullRight)
	{
		oCss.left = "auto";
		oCss.right = oOffset.right+"px";
	}
	else
	{
		oCss.left = oOffset.left+"px";
		oCss.right="auto";
	}

	if(bDropUp)
	{
		oCss.top = "auto";
		oCss.bottom = (oOffset.bottom+iHeight-4)+"px";
	}
	else
	{
		oCss.top = (oOffset.top+28+1).toString()+"px"//iHeight-2)+"px"; // Раньше вычисляли высоту, теперь берем фиксированное значение — 28 — это стандартная высота кнопки.
		oCss.bottom = "auto";
	}

	//console.log("placement oCss 1 : %o", oCss);

	/***/

	$popElement
		.toggleClass("bottom-up", bDropUp)
		.toggleClass("pull-right", bPullRight)
		.css(oCss);

	/**/

	//console.dir($popElement);

	return $popElement;
}
